export default __webpack_public_path__ + "static/media/footer-icon-3.e3395b66.svg";